import React from 'react';
import PropTypes from 'prop-types';
import CTA from '../../Shared/CTA/CTA';
import { extractColors, formatHttpsUrl } from '@utils/utils';
import { CtaSectionStyles } from './CtaSection.styled';

const CtaSection = ({ cta }) => {
  return (
    <CtaSectionStyles>
      {cta && (
        <CTA
          id="stories-cta-section"
          buttonLocation={cta.ctaButtonLocation}
          buttonColors={extractColors(cta.buttonAndTextColors)}
          secondButtonColors={cta.secondButtonColor}
          backgroundColor={extractColors(cta.ctaBackgroundColor)}
          image={
            cta.ctaImage !== null ? formatHttpsUrl(cta.ctaImage.file.url) : null
          }
          imageAlign={cta.ctaImageLocation}
          contentAlign={cta.alignCtaContent}
          headingText={cta.ctaHeader}
          ctaText={cta.ctaIntro}
          buttonText={cta.firstCtaButtonText}
          buttonUrl={cta.firstCtaButtonUrl}
          buttonAutomationId="stories-cta-button-1"
          buttonOpensToNewTab={true}
          gtmClassName="gtm-ugc-survey-exit"
        />
      )}
    </CtaSectionStyles>
  );
};

export default CtaSection;

CtaSection.propTypes = {
  cta: PropTypes.object,
};
